export default __webpack_public_path__ + "static/media/X.7788f75c.svg";